/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { passkeyList } from '../api';
import {
  passkeyListFailed,
  passkeyListRequest,
  passkeyListSuccess,
} from '../reducer/passkeyListSlice';

export function* passkeyListSaga(action: any): Generator<any, void, unknown> {
  const { apiName, data } = action.payload;
  try {
    const response: any = yield call(passkeyList, apiName, data);
    const isSuccessStatus =
      response?.status === 200 ||
      response?.status === '200' ||
      response?.data?.status === 200 ||
      response?.data?.status === '200';

    if (isSuccessStatus) {
      const payload = response?.data ?? {};
      yield put(
        passkeyListSuccess({
          activePasskeys: Array.isArray(payload.activePasskeys)
            ? payload.activePasskeys
            : [],
          userId: payload.userId,
        })
      );
    } else {
      const { status, detail, errorCode, body } = response ?? {};
      yield put(
        passkeyListFailed({
          statusCode: status ?? '500',
          error: {
            errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
            msg: detail ?? body ?? 'An unknown error occurred.',
            statusCode: status ?? '500',
          },
        })
      );
    }
  } catch (error: any) {
    const {
      status = '500',
      errorCode = 'UNKNOWN_ERROR',
      detail = 'An unknown error occurred.',
    } = error?.data ?? error ?? {};
    yield put(
      passkeyListFailed({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}

export function* watchPasskeyListSaga() {
  yield takeLatest(passkeyListRequest.type, passkeyListSaga);
}
